if (module.hot) {
  console.log("Accepting hot reload...");
  module.hot.accept();
}

(async () => {
  const { default: startEasasJsReports } = await import("./indexReports");
  startEasasJsReports();
})();
